import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import './Pages.css';

function FinancialManagement() {
  const { t } = useTranslation();

  return (
    <div className="main-bg">
      <Header />
      <div className="page-container">
        <div className="page-header">
          <h1>{t('services.service5.title')}</h1>
          <div className="page-bar"></div>
        </div>
        
        <div className="page-content">
          <div className="service-detail">
            <div className="service-description">
              <h2>Përshkrimi i Shërbimit</h2>
              <p>{t('services.service5.desc')}</p>
              <p>Shërbimi ynë i menaxhimit financiar përfshin:</p>
              <ul>
                <li>Planifikim dhe buxhetim financiar</li>
                <li>Kontrolli i fluksit të parave</li>
                <li>Optimizimi i strukturës së kapitalit</li>
                <li>Menaxhimi i detyrimit dhe të arkëtueshmeve</li>
                <li>Raportimi financiar i detajuar</li>
              </ul>
            </div>
            
            <div className="service-benefits">
              <h2>Përfitimet</h2>
              <div className="benefits-grid">
                <div className="benefit-card">
                  <h3>Kontroll i Plotë</h3>
                  <p>Mbikëqyrje e vazhdueshme e gjendjes financiare</p>
                </div>
                <div className="benefit-card">
                  <h3>Optimizimi i Burimeve</h3>
                  <p>Përdorimi efikas i burimeve financiare</p>
                </div>
                <div className="benefit-card">
                  <h3>Vendimmarrje e Mençur</h3>
                  <p>Bazuar në të dhëna të sakta dhe të përditësuara</p>
                </div>
                <div className="benefit-card">
                  <h3>Rritje e Likuiditetit</h3>
                  <p>Menaxhim i mirë i fluksit të parave</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default FinancialManagement; 